/**
 * 实体卡 | 虚拟卡 | 卡充值
 */
import Net from '../net';

const NAME = '[CardApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === Card === **/
/** card/query
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.uid
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.type
 * @param {*} data.user_phone
 * @param {*} data.create_time_start
 * @param {*} data.create_time_end
 * @param {*} data.update_time_start
 * @param {*} data.update_time_end
 * @param {*} data.activate_time_start
 * @param {*} data.activate_time_end
 * @param {*} data.status
 * @param {*} data.flag_delete
*/
export async function getCardList(data = {}) {
  Log('getCardList data:', data)
  try {
    const res = await Net.http('card/query', { data })
    Log('getCardList res:', res)
    return res
  } catch (err) {
    Log('getCardList err:', err)
    throw err
  }
}

/** card/update
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.org_id
 * @param {*} data.operator_id
*/
export async function updateCard(data = {}) {
  Log('updateCard data:', data)
  try {
    const res = await Net.http('card/update', { data })
    Log('updateCard res:', res)
    return res
  } catch (err) {
    Log('updateCard err:', err)
    throw err
  }
}

/** card/batch-update-org
 * @param {Object} data
 * @param {*} data.uids
 * @param {*} data.org_id
 * @param {*} data.operator_id
 * @param {*} data.remark
*/
export async function batchUpdateCard(data = {}) {
  Log('batchUpdateCard data:', data)
  try {
    const res = await Net.http('card/batch-update-org', { data })
    Log('batchUpdateCard res:', res)
    return res
  } catch (err) {
    Log('batchUpdateCard err:', err)
    throw err
  }
}

/** card/import-card-list
 * @param {Object} data
 * @param {*} data.file
*/
export async function cardImport(data = {}) {
  Log('cardImport data:', data)
  try {
    const res = await Net.http('card/import-card-list', { data })
    Log('cardImport res:', res)
    return res
  } catch (err) {
    Log('cardImport err:', err)
    throw err
  }
}

/** card/export
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.uid
 * @param {*} data.status
 * @param {*} data.create_time_start
 * @param {*} data.create_time_end
 * @param {*} data.update_time_start
 * @param {*} data.update_time_end
 * @param {*} data.page
*/
export async function exportCard(data = {}) {
  Log('exportCard data:', data)
  try {
    const res = await Net.http('card/export', { data })
    Log('exportCard res:', res)
    return res
  } catch (err) {
    Log('exportCard err:', err)
    throw err
  }
}

/** card/detail
 * @param {Object} data
 * @param {*} data.uid
*/
export async function getCardDetail(data = {}) {
  Log('getCardDetail data:', data)
  try {
    const res = await Net.http('card/detail', { data })
    Log('getCardDetail res:', res)
    return res
  } catch (err) {
    Log('getCardDetail err:', err)
    throw err
  }
}

/** card/detail-by-id
 * @param {Object} data
 * @param {*} data.id
*/
export async function getCardDetailById(data = {}) {
  Log('getCardDetailById data:', data)
  try {
    const res = await Net.http('card/detail-by-id', { data })
    Log('getCardDetailById res:', res)
    return res
  } catch (err) {
    Log('getCardDetailById err:', err)
    throw err
  }
}

/** card/delete
 * @param {Object} data
 * @param {*} data.uid
*/
export async function deleteCard(data = {}) {
  Log('deleteCard data:', data)
  try {
    const res = await Net.http('card/delete', { data })
    Log('deleteCard res:', res)
    return res
  } catch (err) {
    Log('deleteCard err:', err)
    throw err
  }
}

/** card/lossCard
 * @param {Object} data
 * @param {*} data.uid
*/
export async function cardLoss(data = {}) {
  Log('cardLoss data:', data)
  try {
    const res = await Net.http('card/lossCard', { data })
    Log('cardLoss res:', res)
    return res
  } catch (err) {
    Log('cardLoss err:', err)
    throw err
  }
}

/** card/findBack
 * @param {Object} data
 * @param {*} data.uid
*/
export async function findCardBack(data = {}) {
  Log('findCardBack data:', data)
  try {
    const res = await Net.http('card/findBack', { data })
    Log('findCardBack res:', res)
    return res
  } catch (err) {
    Log('findCardBack err:', err)
    throw err
  }
}

/** card/unbind
 * @param {Object} data
 * @param {*} data.uid
*/
export async function unbindCard(data = {}) {
  Log('unbindCard data:', data)
  try {
    const res = await Net.http('card/unbind', { data })
    Log('unbindCard res:', res)
    return res
  } catch (err) {
    Log('unbindCard err:', err)
    throw err
  }
}

/** card/reset
 * @param {Object} data
 * @param {*} data.uid
*/
export async function resetCard(data = {}) {
  Log('resetCard data:', data)
  try {
    const res = await Net.http('card/reset', { data })
    Log('resetCard res:', res)
    return res
  } catch (err) {
    Log('resetCard err:', err)
    throw err
  }
}

/** card/discard
 * @param {Object} data
 * @param {*} data.uid
*/
export async function cardDiscard(data = {}) {
  Log('cardDiscard data:', data)
  try {
    const res = await Net.http('card/discard', { data })
    Log('cardDiscard res:', res)
    return res
  } catch (err) {
    Log('cardDiscard err:', err)
    throw err
  }
}

/** card/update-remark
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.remark
*/
export async function cardRemark(data = {}) {
  Log('cardRemark data:', data)
  try {
    const res = await Net.http('card/update-remark', { data })
    Log('cardRemark res:', res)
    return res
  } catch (err) {
    Log('cardRemark err:', err)
    throw err
  }
}

/** card/order-list
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.page
*/
export async function cardOrderList(data = {}) {
  Log('cardOrderList data:', data)
  try {
    const res = await Net.http('card/order-list', { data })
    Log('cardOrderList res:', res)
    return res
  } catch (err) {
    Log('cardOrderList err:', err)
    throw err
  }
}

/** card/money-list
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.page
*/
export async function cardMoneyList(data = {}) {
  Log('cardMoneyList data:', data)
  try {
    const res = await Net.http('card/money-list', { data })
    Log('cardMoneyList res:', res)
    return res
  } catch (err) {
    Log('cardMoneyList err:', err)
    throw err
  }
}

/** card/log-list
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.page
*/
export async function cardLogList(data = {}) {
  Log('cardLogList data:', data)
  try {
    const res = await Net.http('card/log-list', { data })
    Log('cardLogList res:', res)
    return res
  } catch (err) {
    Log('cardLogList err:', err)
    throw err
  }
}

/** card/error-log-list
 * @param {Object} data
 * @param {*} data.card_uid
 * @param {*} data.page
*/
export async function cardErrorList(data = {}) {
  Log('cardErrorList data:', data)
  try {
    const res = await Net.http('card/error-log-list', { data })
    Log('cardErrorList res:', res)
    return res
  } catch (err) {
    Log('cardErrorList err:', err)
    throw err
  }
}

/** card/synchronization
 * @param {Object} data
 * @param {*} data.uid
*/
export async function cardSynchronization(data = {}) {
  Log('cardSynchronization data:', data)
  try {
    const res = await Net.http('card/synchronization', { data })
    Log('cardSynchronization res:', res)
    return res
  } catch (err) {
    Log('cardSynchronization err:', err)
    throw err
  }
}

/** card/recharge
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.money
*/
export async function cardRechargeMoney(data = {}) {
  Log('cardRechargeMoney data:', data)
  try {
    const res = await Net.http('card/recharge', { data })
    Log('cardRechargeMoney res:', res)
    return res
  } catch (err) {
    Log('cardRechargeMoney err:', err)
    throw err
  }
}

/** card/recharge
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.resource_package_config_id
 * @param {*} data.data
*/
export async function cardRechargeTime(data = {}) {
  Log('cardRechargeTime data:', data)
  try {
    const res = await Net.http('card/recharge', { data })
    Log('cardRechargeTime res:', res)
    return res
  } catch (err) {
    Log('cardRechargeTime err:', err)
    throw err
  }
}

/** card/deduct
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.money
*/
export async function cardAbatementMoney(data = {}) {
  Log('cardAbatementMoney data:', data)
  try {
    const res = await Net.http('card/deduct', { data })
    Log('cardAbatementMoney res:', res)
    return res
  } catch (err) {
    Log('cardAbatementMoney err:', err)
    throw err
  }
}

/** card/deduct
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.day
 * @param {*} data.time
 * @param {*} data.package_id
*/
export async function cardAbatementTime(data = {}) {
  Log('cardAbatementTime data:', data)
  try {
    const res = await Net.http('card/deduct', { data })
    Log('cardAbatementTime res:', res)
    return res
  } catch (err) {
    Log('cardAbatementTime err:', err)
    throw err
  }
}


/** === VirtualCard === **/
/** virtual-card/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.uid
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.type
 * @param {*} data.user_phone
 * @param {*} data.status
 * @param {*} data.create_time_start
 * @param {*} data.create_time_end
 * @param {*} data.flag_delete
*/
export async function getVirtualCardList(data = {}) {
  Log('getVirtualCardList data:', data)
  try {
    const res = await Net.http('virtual-card/list', { data })
    Log('getVirtualCardList res:', res)
    return res
  } catch (err) {
    Log('getVirtualCardList err:', err)
    throw err
  }
}

/** virtual-card/update-org
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.org_id
 * @param {*} data.operator_id
*/
export async function updateVirtualCard(data = {}) {
  Log('updateVirtualCard data:', data)
  try {
    const res = await Net.http('virtual-card/update-org', { data })
    Log('updateVirtualCard res:', res)
    return res
  } catch (err) {
    Log('updateVirtualCard err:', err)
    throw err
  }
}

/** virtual-card/batch-update-org
 * @param {Object} data
 * @param {*} data.uids
 * @param {*} data.org_id
 * @param {*} data.operator_id
*/
export async function batchUpdateVirtualCard(data = {}) {
  Log('batchUpdateVirtualCard data:', data)
  try {
    const res = await Net.http('virtual-card/batch-update-org', { data })
    Log('batchUpdateVirtualCard res:', res)
    return res
  } catch (err) {
    Log('batchUpdateVirtualCard err:', err)
    throw err
  }
}

/** virtual-card/delete
 * @param {Object} data
 * @param {*} data.uid
*/
export async function deleteVirtualCard(data = {}) {
  Log('deleteVirtualCard data:', data)
  try {
    const res = await Net.http('virtual-card/delete', { data })
    Log('deleteVirtualCard res:', res)
    return res
  } catch (err) {
    Log('deleteVirtualCard err:', err)
    throw err
  }
}

/** virtual-card/detail
 * @param {Object} data
 * @param {*} data.uid
*/
export async function getVirtualCardDetail(data = {}) {
  Log('getVirtualCardDetail data:', data)
  try {
    const res = await Net.http('virtual-card/detail', { data })
    Log('getVirtualCardDetail res:', res)
    return res
  } catch (err) {
    Log('getVirtualCardDetail err:', err)
    throw err
  }
}

/** virtual-card/detail-by-id
 * @param {Object} data
 * @param {*} data.id
*/
export async function getVirtualCardDetailById(data = {}) {
  Log('getVirtualCardDetailById data:', data)
  try {
    const res = await Net.http('virtual-card/detail-by-id', { data })
    Log('getVirtualCardDetailById res:', res)
    return res
  } catch (err) {
    Log('getVirtualCardDetailById err:', err)
    throw err
  }
}

/** virtual-card/detail-by-delete
 * @param {Object} data
 * @param {*} data.uid
*/
export async function getVirtualCardDetailByDelete(data = {}) {
  Log('getVirtualCardDetailByDelete data:', data)
  try {
    const res = await Net.http('virtual-card/detail-by-delete', { data })
    Log('getVirtualCardDetailByDelete res:', res)
    return res
  } catch (err) {
    Log('getVirtualCardDetailByDelete err:', err)
    throw err
  }
}

/** virtual-card/create
 * @param {Object} data
 * @param {*} data.phone
 * @param {*} data.org_id
 * @param {*} data.type
*/
export async function createVirtualCard(data = {}) {
  Log('createVirtualCard data:', data)
  try {
    const res = await Net.http('virtual-card/create', { data })
    Log('createVirtualCard res:', res)
    return res
  } catch (err) {
    Log('createVirtualCard err:', err)
    throw err
  }
}

/** virtual-card/discard
 * @param {Object} data
 * @param {*} data.uid
*/
export async function virtualCardDiscard(data = {}) {
  Log('virtualCardDiscard data:', data)
  try {
    const res = await Net.http('virtual-card/discard', { data })
    Log('virtualCardDiscard res:', res)
    return res
  } catch (err) {
    Log('virtualCardDiscard err:', err)
    throw err
  }
}

/** virtual-card/export
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.uid
 * @param {*} data.node_type
 * @param {*} data.create_time_start
 * @param {*} data.create_time_end
 * @param {*} data.page
*/
export async function exportVirtualCard(data = {}) {
  Log('exportVirtualCard data:', data)
  try {
    const res = await Net.http('virtual-card/export', { data })
    Log('exportVirtualCard res:', res)
    return res
  } catch (err) {
    Log('exportVirtualCard err:', err)
    throw err
  }
}

/** virtual-card/order-list
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.page
*/
export async function virtualCardOrderList(data = {}) {
  Log('virtualCardOrderList data:', data)
  try {
    const res = await Net.http('virtual-card/order-list', { data })
    Log('virtualCardOrderList res:', res)
    return res
  } catch (err) {
    Log('virtualCardOrderList err:', err)
    throw err
  }
}

/** virtual-card/vin-order-list
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.page
*/
export async function virtualCardVinOrderList(data = {}) {
  Log('virtualCardVinOrderList data:', data)
  try {
    const res = await Net.http('virtual-card/vin-order-list', { data })
    Log('virtualCardVinOrderList res:', res)
    return res
  } catch (err) {
    Log('virtualCardVinOrderList err:', err)
    throw err
  }
}

/** virtual-card/money-list
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.page
*/
export async function virtualCardMoneyList(data = {}) {
  Log('virtualCardMoneyList data:', data)
  try {
    const res = await Net.http('virtual-card/money-list', { data })
    Log('virtualCardMoneyList res:', res)
    return res
  } catch (err) {
    Log('virtualCardMoneyList err:', err)
    throw err
  }
}

/** virtual-card/log-list
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.page
*/
export async function virtualCardLogList(data = {}) {
  Log('virtualCardLogList data:', data)
  try {
    const res = await Net.http('virtual-card/log-list', { data })
    Log('virtualCardLogList res:', res)
    return res
  } catch (err) {
    Log('virtualCardLogList err:', err)
    throw err
  }
}

/** virtual-card/recharge
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.money
*/
export async function virtualCardRechargeMoney(data = {}) {
  Log('virtualCardRechargeMoney data:', data)
  try {
    const res = await Net.http('virtual-card/recharge', { data })
    Log('virtualCardRechargeMoney res:', res)
    return res
  } catch (err) {
    Log('virtualCardRechargeMoney err:', err)
    throw err
  }
}

/** virtual-card/recharge
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.resource_package_config_id
 * @param {*} data.data
*/
export async function virtualCardRechargeTime(data = {}) {
  Log('virtualCardRechargeTime data:', data)
  try {
    const res = await Net.http('virtual-card/recharge', { data })
    Log('virtualCardRechargeTime res:', res)
    return res
  } catch (err) {
    Log('virtualCardRechargeTime err:', err)
    throw err
  }
}

/** virtual-card/deduct
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.money
*/
export async function virtualCardAbatementMoney(data = {}) {
  Log('virtualCardAbatementMoney data:', data)
  try {
    const res = await Net.http('virtual-card/deduct', { data })
    Log('virtualCardAbatementMoney res:', res)
    return res
  } catch (err) {
    Log('virtualCardAbatementMoney err:', err)
    throw err
  }
}

/** virtual-card/deduct
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.day
 * @param {*} data.time
 * @param {*} data.package_id
*/
export async function virtualCardAbatementTime(data = {}) {
  Log('virtualCardAbatementTime data:', data)
  try {
    const res = await Net.http('virtual-card/deduct', { data })
    Log('virtualCardAbatementTime res:', res)
    return res
  } catch (err) {
    Log('virtualCardAbatementTime err:', err)
    throw err
  }
}


/** === CardRechage === **/
/** card/money-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.uid
 * @param {*} data.subject
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function cardRechageRealityList(data = {}) {
  Log('cardRechageRealityList data:', data)
  try {
    const res = await Net.http('card/money-list', { data })
    Log('cardRechageRealityList res:', res)
    return res
  } catch (err) {
    Log('cardRechageRealityList err:', err)
    throw err
  }
}

/** virtual-card/money-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.uid
 * @param {*} data.subject
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function cardRechageVirtualList(data = {}) {
  Log('cardRechageVirtualList data:', data)
  try {
    const res = await Net.http('virtual-card/money-list', { data })
    Log('cardRechageVirtualList res:', res)
    return res
  } catch (err) {
    Log('cardRechageVirtualList err:', err)
    throw err
  }
}

/** recharge-task/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.name
 * @param {*} data.card_type
 * @param {*} data.type
 * @param {*} data.recharge_type
 * @param {*} data.money
 * @param {*} data.data
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function saveCardRechage(data = {}) {
  Log('saveCardRechage data:', data)
  try {
    const res = await Net.http('recharge-task/save', { data })
    Log('saveCardRechage res:', res)
    return res
  } catch (err) {
    Log('saveCardRechage err:', err)
    throw err
  }
}

/** recharge-task/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.type
 * @param {*} data.card_type
*/
export async function getCardRechageList(data = {}) {
  Log('getCardRechageList data:', data)
  try {
    const res = await Net.http('recharge-task/list', { data })
    Log('getCardRechageList res:', res)
    return res
  } catch (err) {
    Log('getCardRechageList err:', err)
    throw err
  }
}

/** recharge-task/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getCardRechageDetail(data = {}) {
  Log('getCardRechageDetail data:', data)
  try {
    const res = await Net.http('recharge-task/detail', { data })
    Log('getCardRechageDetail res:', res)
    return res
  } catch (err) {
    Log('getCardRechageDetail err:', err)
    throw err
  }
}

/** recharge-task/execute
 * @param {Object} data
 * @param {*} data.id
*/
export async function cardRechageExecute(data = {}) {
  Log('cardRechageExecute data:', data)
  try {
    const res = await Net.http('recharge-task/execute', { data })
    Log('cardRechageExecute res:', res)
    return res
  } catch (err) {
    Log('cardRechageExecute err:', err)
    throw err
  }
}

/** recharge-task-member/batch-create
 * @param {Object} data
 * @param {*} data.task_id
 * @param {*} data.card_ids
*/
export async function cardRechageTaskMemberAdd(data = {}) {
  Log('cardRechageTaskMemberAdd data:', data)
  try {
    const res = await Net.http('recharge-task-member/batch-create', { data })
    Log('cardRechageTaskMemberAdd res:', res)
    return res
  } catch (err) {
    Log('cardRechageTaskMemberAdd err:', err)
    throw err
  }
}

/** recharge-task-member/list
 * @param {Object} data
 * @param {*} data.task_id
 * @param {*} data.page
 * @param {*} data.card_uid
 * @param {*} data.card_id
*/
export async function cardRechageTaskMemberList(data = {}) {
  Log('cardRechageTaskMemberList data:', data)
  try {
    const res = await Net.http('recharge-task-member/list', { data })
    Log('cardRechageTaskMemberList res:', res)
    return res
  } catch (err) {
    Log('cardRechageTaskMemberList err:', err)
    throw err
  }
}

/** recharge-task-member/delete
 * @param {Object} data
 * @param {*} data.task_id
 * @param {*} data.id
*/
export async function cardRechageTaskMemberRemove(data = {}) {
  Log('cardRechageTaskMemberRemove data:', data)
  try {
    const res = await Net.http('recharge-task-member/delete', { data })
    Log('cardRechageTaskMemberRemove res:', res)
    return res
  } catch (err) {
    Log('cardRechageTaskMemberRemove err:', err)
    throw err
  }
}

/** card/list-by-recharge-task
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.task_id
 * @param {*} data.org_id
*/
export async function cardRechageRealityTaskList(data = {}) {
  Log('cardRechageRealityTaskList data:', data)
  try {
    const res = await Net.http('card/list-by-recharge-task', { data })
    Log('cardRechageRealityTaskList res:', res)
    return res
  } catch (err) {
    Log('cardRechageRealityTaskList err:', err)
    throw err
  }
}

/** virtual-card/list-by-recharge-task
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.task_id
 * @param {*} data.org_id
*/
export async function cardRechageVirtualTaskList(data = {}) {
  Log('cardRechageVirtualTaskList data:', data)
  try {
    const res = await Net.http('virtual-card/list-by-recharge-task', { data })
    Log('cardRechageVirtualTaskList res:', res)
    return res
  } catch (err) {
    Log('cardRechageVirtualTaskList err:', err)
    throw err
  }
}
